import { useEffect, useRef, useState } from 'react';
import {
  LogOutButton,
  NavLinkStyled,
  NavStyled,
  SignInButton,
  SignUpButton,
} from './Nav.styled';

import logo from '../../assets/images/travelutionLogo.png';
import { Div, UserImageCircle } from '../../styles/Styles';
import { MenuIcon } from '../../styles/svg';
import { handleSmoothScroll, navLinks, pathname } from '../../helpers/helpers';
import { DropdownMenu } from '../DropdownMenu/dropdownMenu';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { DASHBOARD_PROFILE_ORDERS, SIGNIN, SIGNUP } from 'routes/routes';
import { useAppSelector } from 'app/hooks';

import { colors } from 'styles';
import { ModalComponent } from 'components/Modal/Modal';
import { Logout } from './Logout';

export const Nav = () => {
  const [sticky, setSticky] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const { user } = useAppSelector((state) => state.authentication);
  const location = useLocation();

  const dropdownRef = useRef(null);

  const handleMenu = () => setDropdown((prevState) => !prevState);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;

      for (const link of navLinks) {
        const sectionId = link.path.replace('#', '');
        const section = document.getElementById(sectionId);

        if (section) {
          const { top, height } = section.getBoundingClientRect();
          const sectionTop = top + window.scrollY;
          const sectionBottom = sectionTop + height;

          if (
            scrollPosition >= sectionTop &&
            scrollPosition < sectionBottom - 50
          ) {
            setActiveSection(link.path);
            window.history.replaceState(null, '', link.path);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const targetId = window.location.hash.replace('#', '');
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  useEffect(() => {
    if (dropdown) {
      handleMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 50 ? setSticky(true) : setSticky(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  return (
    <>
      <NavStyled $sticky={sticky}>
        <Div $flex $alignCenter $gap='80px'>
          <Link to='/'>
            <img src={logo} alt='travelution' />
          </Link>
          <Div $desktop $flex $alignCenter $gap='30px'>
            {navLinks.map(({ path, name }, i) => (
              <NavLinkStyled
                key={i}
                to={path}
                onClick={(e) => handleSmoothScroll(e, path, location, navigate)}
                style={{ color: activeSection === path ? colors.primary : '' }}
              >
                {name}
              </NavLinkStyled>
            ))}
          </Div>
        </Div>
        <Div $flex $alignCenter $gap='24px'>
          {user && !location.pathname.includes('google-complete') ? (
            <Div $flex $alignCenter $gap='10px'>
              <Link to={DASHBOARD_PROFILE_ORDERS}>
                <UserImageCircle
                  image={user.profileImage}
                  avatar
                  avatarSize='20px'
                  size='45px'
                />
              </Link>
              <LogOutButton onClick={() => setIsOpen(true)}>
                Logout
              </LogOutButton>
            </Div>
          ) : (
            <>
              {location.pathname.includes('signup') ||
              location.pathname.includes('signin') ||
              location.pathname.includes('google-complete') ||
              location.pathname.includes('reset-password') ? (
                <></>
              ) : (
                <>
                  <SignInButton onClick={() => navigate(SIGNIN)}>
                    Sign In
                  </SignInButton>
                  <Div $desktop>
                    <SignUpButton onClick={() => navigate(SIGNUP)}>
                      Sign Up
                    </SignUpButton>
                  </Div>
                </>
              )}
            </>
          )}

          <Div $mobile ref={dropdownRef}>
            <Div $pointer onClick={handleMenu}>
              <MenuIcon />
            </Div>
            <DropdownMenu
              isOpen={dropdown}
              setIsOpen={setDropdown}
              location={location}
              navigate={navigate}
              activeSection={activeSection}
            />
          </Div>
        </Div>
      </NavStyled>
      <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title='Logout'>
        <Logout setIsOpen={setIsOpen} />
      </ModalComponent>
    </>
  );
};
